import { objectWithoutProperties as _objectWithoutProperties, extends as _extends, slicedToArray as _slicedToArray } from '../../../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'emotion-icons/material';
import { HEADER } from '../../utils/dataTrackingValues.js';
import Typography from '../Typography/index.js';
import { MobileNav as MobileNav$2 } from './Header.styles.js';

var _excluded = ["dark", "navData", "CustomLink"];
var MobileNav = function MobileNav(_ref) {
  var _ref$dark = _ref.dark,
    dark = _ref$dark === void 0 ? false : _ref$dark,
    navData = _ref.navData,
    _ref$CustomLink = _ref.CustomLink,
    CustomLink = _ref$CustomLink === void 0 ? null : _ref$CustomLink,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default.createElement(MobileNav$2, _extends({
    dark: dark,
    className: "leshen-mobilenav"
  }, props), /*#__PURE__*/React__default.createElement(List, {
    CustomLink: CustomLink,
    items: navData,
    className: "list"
  }));
};

// A List has ListItems, and ListItems may have Lists in themselves.
var List = function List(_ref2) {
  var _ref2$parent = _ref2.parent,
    parent = _ref2$parent === void 0 ? null : _ref2$parent,
    items = _ref2.items,
    _ref2$setSubOpen = _ref2.setSubOpen,
    setSubOpen = _ref2$setSubOpen === void 0 ? null : _ref2$setSubOpen,
    _ref2$CustomLink = _ref2.CustomLink,
    CustomLink = _ref2$CustomLink === void 0 ? null : _ref2$CustomLink;
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("ul", null, setSubOpen && /*#__PURE__*/React__default.createElement("button", {
    "data-testid": "mobile-menu-back-button",
    type: "button",
    className: "back-button",
    onClick: function onClick() {
      setSubOpen(false);
    }
  }, /*#__PURE__*/React__default.createElement(ChevronLeft, null), /*#__PURE__*/React__default.createElement(Typography, {
    rendersAs: "span"
  }, "Back")), /*#__PURE__*/React__default.createElement(React__default.Fragment, null, parent && /*#__PURE__*/React__default.createElement(ListItem, {
    CustomLink: CustomLink,
    key: parent.text,
    item: parent
  }), items === null || items === void 0 ? void 0 : items.map(function (item) {
    return /*#__PURE__*/React__default.createElement(ListItem, {
      CustomLink: CustomLink,
      key: item.text,
      item: item
    });
  }))));
};

// The ListItem component is called from a List and may have a List as a child.
// The ListItem holds the state of whether its child List is open or not, and
// the child List controls when to close itself.
function ListItem(_ref3) {
  var item = _ref3.item,
    _ref3$CustomLink = _ref3.CustomLink,
    CustomLink = _ref3$CustomLink === void 0 ? null : _ref3$CustomLink;
  var nav = (item === null || item === void 0 ? void 0 : item.megaLinks) || (item === null || item === void 0 ? void 0 : item.subnav);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    subOpen = _useState2[0],
    setSubOpen = _useState2[1];
  return /*#__PURE__*/React__default.createElement("li", null, nav ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("button", {
    "data-tracking": HEADER.MOBILE_NAVIGATION_ITEM,
    type: "button",
    onClick: function onClick() {
      return setSubOpen(!subOpen);
    }
  }, /*#__PURE__*/React__default.createElement(Typography, {
    rendersAs: "span"
  }, item.text), /*#__PURE__*/React__default.createElement(ChevronRight, null)), subOpen && /*#__PURE__*/React__default.createElement(List, {
    parent: {
      text: item.text,
      href: (item === null || item === void 0 ? void 0 : item.link) || item.href
    },
    items: (item === null || item === void 0 ? void 0 : item.megaLinks) || item.subnav,
    setSubOpen: setSubOpen,
    CustomLink: CustomLink
  })) : CustomLink ? /*#__PURE__*/React__default.createElement(CustomLink, {
    to: (item === null || item === void 0 ? void 0 : item.link) || item.href,
    "data-tracking": HEADER.MOBILE_NAVIGATION_ITEM
    // eslint-disable-next-line prettier/prettier
    ,
    onClick: function onClick() {
      return HEADER.LINKS.handleClick(item.text, (item === null || item === void 0 ? void 0 : item.link) || item.href);
    }
  }, item.text) : /*#__PURE__*/React__default.createElement("a", {
    href: (item === null || item === void 0 ? void 0 : item.link) || item.href
  }, item.text));
}
var MobileNav$1 = MobileNav;

export { MobileNav$1 as default };
//# sourceMappingURL=MobileNav.js.map
